import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-and-conditions-content',
  templateUrl: './terms-and-conditions-content.component.html',
  styleUrls: ['./terms-and-conditions-content.component.scss']
})
export class TermsAndConditionsContentComponent {

}
